import React from "react"

import { Element } from "legacy/components/shared/base"
import Grid from "legacy/components/shared/Grid"
import HeroImage from "./HeroImage"
import HeroText from "./HeroText"
import { Maybe } from "types/Maybe"
import { PrismicPageDataBodySplitHero } from "types/__generated__/gatsby-graphql"

interface OwnProps {
  data?: Maybe<PrismicPageDataBodySplitHero>
}

type SplitHeroProps = OwnProps

const SplitHero: React.FC<SplitHeroProps> = ({
  data,
}): React.ReactElement | null => {
  if (!data) return null

  return (
    <Element>
      <Grid gridTemplateColumns="1col" maxWidth="contentWidth">
        <HeroImage data={data.primary} />
        <HeroText data={data} />
      </Grid>
    </Element>
  )
}

export default SplitHero
